module.exports = __webpack_public_path__ + "img/idea-icon.02e49a58.svg";